import React,{useState,useEffect} from 'react'


import FinanceLayout from '../../../../../../layout/components/FinanceLayout';
import MonthlyDateSelect from '../../../../../../components/AppInput/MonthlyDateSelect';
import reportServices from '../reportServices';
import DayBookSummary from '../components/DayBookSummary';
import DaybookDataGrid from '../components/DaybookDataGrid';
import { Cancel, CheckCircle, HourglassBottom } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';


function VoucherDashboardPage() {

    const [loading,setLoadingStatus] = useState(false);
    const [listType,setListType] = useState("finalized")
    const [voucherList,setVoucherList] = useState();
    const [draftList,setDraftList] = useState();
    const [finalizedList,setFinalizedList] = useState();
    const [cancelledList,setCancelledList] = useState();

    const [filter,setFilter] = useState(null);

    const getVoucherList =() =>{
        setLoadingStatus(true);
        reportServices.getAllVoucherList(filter).then(res=>{
            setFinalizedList(res.data.finalized);
            setDraftList(res.data.draft);
            setCancelledList(res.data.cancelled);
            setVoucherList(res.data[listType]);
        }).catch(error=>{

        }).finally(()=>{
          setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        getVoucherList();
    },[filter])


    useEffect(()=>{
      if(listType === "finalized") setVoucherList(finalizedList);
      if(listType === "draft") setVoucherList(draftList);
      if(listType === "cancelled") setVoucherList(cancelledList);
    },[listType])

    return (
        <FinanceLayout>
          
          <div className='row my-2'>
              <div className='col-md-8'>
                <div className="bg-white p-2">
                  <button onClick={()=>setListType("finalized")} className={listType === "finalized" ? 'me-2 btn btn-success' :'me-2 btn btn-outline-success'}><CheckCircle/> Finalized Voucher</button>
                  <button onClick={()=>setListType("draft")}     className={listType === "draft" ? 'me-2 btn btn-warning' : 'me-2 btn btn-outline-warning'}><HourglassBottom/> Draft Voucher</button>
                  <button onClick={()=>setListType("cancelled")} className={listType === "cancelled" ? 'me-2 btn btn-danger' : 'me-2 btn btn-outline-danger'}><Cancel /> Cancelled Voucher</button>
                </div>
              </div>
              <div className='col-md-4 '>
                  <div className="bg-white p-2">
                  <span className=''><MonthlyDateSelect filter={filter} setFilter={setFilter} /></span>
                  </div>
              </div>
          
              {loading && 
                <div className='text-center mt-5'>
                  <CircularProgress/>
                </div>
              }
              {!loading &&
              <div className='col-md-12 mt-2'>
                  {voucherList && <DayBookSummary voucherList={voucherList} /> }
                  {voucherList && <DaybookDataGrid voucherList={voucherList} getVoucherList={getVoucherList} />}
              </div>
              }
          </div>
          
        </FinanceLayout>
    )
}

export default VoucherDashboardPage